import { DateFormats } from '../../../types';

const FORMATS: Record<DateFormats, Intl.DateTimeFormatOptions> = {
  // January 14, 2022
  date_without_dow: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'GMT',
  },

  // Friday, January 14, 2022
  date_with_dow: {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    timeZone: 'GMT',
  },

  // 1/14/22
  short_date: {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    timeZone: 'GMT',
  },

  // 01/14/2022
  short_date_alt: {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'GMT',
  },

  // January 14, 2022, 4:00 PM
  date_and_time: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'GMT',
  },

  // Jan 14
  month_and_day: {
    day: 'numeric',
    month: 'short',
    timeZone: 'GMT',
  },

  // Saturday
  day_of_week_only: {
    weekday: 'long',
    timeZone: 'GMT',
  },

  // 14
  day_of_month: {
    day: 'numeric',
    timeZone: 'GMT',
  },

  // Jan
  month_short: {
    month: 'short',
    timeZone: 'GMT',
  },

  // January
  month: {
    month: 'long',
    timeZone: 'GMT',
  },

  // Oct 14, 2022
  short_month_day_year: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'GMT',
  },

  // 3:45 PM
  time: {
    hour: 'numeric',
    minute: '2-digit',
    timeZone: 'GMT',
  },

  // Monday, November 14
  day_of_week_long: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    timeZone: 'GMT',
  },
};

export default FORMATS;
